import classNames from "classnames";
import moment from "moment";
import React from "react";
import {
	TBallastRecord,
	TBallastPlace,
	EBallastOperationCodes,
} from "../../../../../redux/app/ballast/@types";
import { TBallast_Exceptional } from "../../../../../redux/app/ballast/groups/exceptional";
import CommaSeparator from "../../../../_common/CommaSeparator";
import ballastUtils from "redux/app/ballast/utils";
import BallastTableRows from "../_elements/BallastTableRows";

import versions from "../../../../../redux/app/ballast/versions";

type OwnProps = {
	ballastRecord: TBallastRecord;
	isStrikedOff?: boolean;
};
type ExceptionalOperationPreviewProps = OwnProps;
function ExceptionalOperationPreview(props: ExceptionalOperationPreviewProps) {
	const record = props.ballastRecord as TBallast_Exceptional;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);
	const { placeOfBallast, operationCode } =
		props.ballastRecord as TBallast_Exceptional;

	function renderMain() {
		if (record.version === versions[0].value) {
			return (
				<BallastTableRows
					record={record}
					tableRows={[
						[operationDate, "E", "1", renderItemP1()],
						[null, null, "2", renderItemP2()],
						[null, null, "3", renderItemP3()],
						[null, null, "4", renderItemP4()],
						[null, null, "5", renderItemP5()],
						[null, null, "6", renderItemP6()],
						[null, null, "NOTE", record.remarks],
					]}
				/>
			);
		} else {
			return (
				<BallastTableRows
					record={record}
					tableRows={[
						[operationDate, null, "3.5.1", renderItem3P5P1()],
						[null, null, "3.5.2", renderItem3P5P2()],
						[null, null, "3.5.3", renderItem3P5P3()],
						[null, null, "3.5.4", renderItem3P5P4()],
						[null, null, "3.5.5", renderItem3P5P5()],
						[null, null, "NOTE", record.remarks],
					]}
				/>
			);
		}
	}

	// MEPC.369(80)
	function renderItemP1() {
		const smtStartDate = record.tanks[0].startDate;
		const smtStartTime = record.tanks[0].startTime;
		if (record.timeZone) {
			const dateTimeLocal = `${smtStartDate}T${smtStartTime}:00${record.timeZone}`;
			const utcTime = moment.utc(dateTimeLocal);
			return (
				<>
					{record.placeOfBallast.place === "IN_PORT" ? (
						<>
							Start - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtStartTime} SMT) on{" "}
							{moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} at{" "}
							{record.placeOfBallast.portName}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							Start - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtStartTime} SMT) on{" "}
							{moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} at Lat{" "}
							{record.placeOfBallast.startPosition.latitude} / Long{" "}
							{record.placeOfBallast.startPosition.longitude}
						</>
					) : null}
				</>
			);
		} else {
			return (
				<>
					{record.placeOfBallast.place === "IN_PORT" ? (
						<>
							Start - {record.tanks[0].startTime} hrs (UTC) on{" "}
							{moment(record.tanks[0].startDate, "YYYY-MM-DD").format(
								"DD-MMM-YYYY"
							)}{" "}
							at {record.placeOfBallast.portName}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							Start - {record.tanks[0].startTime} hrs (UTC) on{" "}
							{moment(record.tanks[0].startDate, "YYYY-MM-DD").format(
								"DD-MMM-YYYY"
							)}{" "}
							at Lat {record.placeOfBallast.startPosition.latitude} / Long{" "}
							{record.placeOfBallast.startPosition.longitude}
						</>
					) : null}
				</>
			);
		}
	}
	function renderItemP2() {
		const smtEndDate = record.tanks[record.tanks.length - 1].endDate;
		const smtEndTime = record.tanks[record.tanks.length - 1].endTime;
		if (record.timeZone) {
			const dateTimeLocal = `${smtEndDate}T${smtEndTime}:00${record.timeZone}`;
			const utcTime = moment.utc(dateTimeLocal);
			return (
				<>
					{record.placeOfBallast.place === "IN_PORT" ? (
						<>
							Completion - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtEndTime} SMT) on{" "}
							{moment(smtEndDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
							{/* on{' '}
                            {moment(smtEndDate, 'YYYY-MM-DD').format(
                                'DD-MMM-YYYY'
                            )}{' '} */}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							Completion - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtEndTime} SMT) on{" "}
							{moment(smtEndDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
							{/* on{' '}
                            {moment(smtEndDate, 'YYYY-MM-DD').format(
                                'DD-MMM-YYYY'
                            )}{' '} */}
						</>
					) : null}
				</>
			);
		} else {
			return (
				<>
					{record.placeOfBallast.place === "IN_PORT" ? (
						<>
							Completion - {record.tanks[record.tanks.length - 1].endTime} hrs
							(UTC)
							{/* on{' '}
                            {moment(
                                record.tanks[record.tanks.length - 1].endDate,
                                'YYYY-MM-DD'
                            ).format('DD-MMM-YYYY')}{' '} */}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							Completion - {record.tanks[record.tanks.length - 1].endTime} hrs
							(UTC)
							{/* on{' '}
                            {moment(
                                record.tanks[record.tanks.length - 1].endDate,
                                'YYYY-MM-DD'
                            ).format('DD-MMM-YYYY')}{' '} */}
						</>
					) : null}
				</>
			);
		}
	}
	function renderItemP3() {
		return (
			<h4 className="font-medium uppercase">
				{record.type} of water{" "}
				{record.type === "Ingress" || record.type === "Uptake"
					? "into"
					: "from"}{" "}
				ballast tank
			</h4>
		);
	}
	function renderItemP4() {
		let tankNames = "";
		record.tanks.forEach((tank, index) => {
			tankNames += tank.selectedTank.tankCode;
			if (index !== record.tanks.length - 1) {
				tankNames += ",";
			}
		});
		return tankNames;
	}
	function renderItemP5() {
		return (
			<h4 className="font-medium uppercase">
				{/* {record.totalOperatedWaterVolume} M³ */}
				{record.ballastROB.toFixed(2)} M³
			</h4>
		);
	}
	function renderItemP6() {
		return (
			<h4 className="font-medium uppercase">{record.circumstantialRemarks}</h4>
		);
	}

	// MEPC 70
	function renderItem3P5P1() {
		return (
			<h4 className="font-medium uppercase">
				{moment(record.tanks[0].startDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
				{record.tanks[0].startTime} to{" "}
				{moment(
					record.tanks[record.tanks.length - 1].endDate,
					"YYYY-MM-DD"
				).format("DD-MMM-YYYY")}{" "}
				{record.tanks[record.tanks.length - 1].endTime}
			</h4>
		);
	}
	function renderItem3P5P2() {
		return (
			<h4 className="font-medium uppercase">
				{validatePlaceOfBallastPreview(placeOfBallast)}
			</h4>
		);
	}
	function renderItem3P5P3() {
		return (
			<h4 className="font-medium uppercase">
				Discharged: {record.totalOperatedWaterVolume} M³, Remaining:{" "}
				{record.ballastROB
					? record.tanks
							.reduce<number>((result, currentItem) => {
								return result + currentItem.newRetainedQuantity;
							}, 0)
							.toFixed(2)
					: (
							record.tanks.reduce<number>((result, currentItem) => {
								return (
									result +
									ballastUtils.getOperationalRetainedQuantity(currentItem)
								);
							}, 0) - record.totalOperatedWaterVolume
					  ).toFixed(2)}
				M³ <br />
				{operationCode ==
				EBallastOperationCodes.ACCIDENTAL_DISCHARGE_OF_BALLAST_WATER
					? "FROM"
					: "FROM CARGO TANKS"}{" "}
				<CommaSeparator
					items={record.tanks.map((tank, index) => tank.selectedTank.tankCode)}
				/>
			</h4>
		);
	}
	function renderItem3P5P4() {
		return (
			<h4 className="font-medium uppercase">{record.circumstantialRemarks}</h4>
		);
	}
	function renderItem3P5P5() {
		return (
			<h4 className="font-medium uppercase">
				{record.isBallastWaterTreatmentPlanUsed ? "YES" : "NO"}
			</h4>
		);
	}

	const validatePlaceOfBallastPreview = (placeOfBallast: TBallastPlace) => {
		if (placeOfBallast.place) {
			return placeOfBallast.place === "AT_RECEPTION_FACILITY" ? (
				<>
					{moment(placeOfBallast.startDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
					{placeOfBallast.startTime}, {placeOfBallast.originOfBallast}
				</>
			) : placeOfBallast.place === "IN_PORT" ? (
				<>{placeOfBallast.portName}</>
			) : placeOfBallast.place === "AT_SEA" ? (
				<>
					From {placeOfBallast.startPosition.latitude},{" "}
					{placeOfBallast.startPosition.longitude}, to{" "}
					{placeOfBallast.endPosition.latitude},{" "}
					{placeOfBallast.endPosition.longitude}
				</>
			) : null;
		} else {
			return <>NA</>;
		}
	};

	return renderMain();
}

export default ExceptionalOperationPreview;
